import { getStartPageUrl } from '@buffer-mono/app-shell/src/common/utils/urls'
import {
  Button,
  CriticalIcon,
  LockOpenIcon,
  Text,
  useIsMobileScreenSize,
} from '@buffer-mono/popcorn'

import { useHasOrganizationAction } from '~publish/contexts/AccountContext'
import { UnlockChannelDialog } from '~publish/components/UnlockChannelDialog'

import { isStartPage } from '../../shared/utils/isStartPage'
import type { ChannelMask } from '../hooks/useChannelsForSettings'
import { Status } from '../utils/getChannelStatus'

import type { JSX } from 'react'

interface ChannelStatusSectionProps {
  channel: ChannelMask
  status: Status
  refreshChannelConnection: (cta: string) => void
}
const ChannelStatusSection = ({
  channel,
  status,
  refreshChannelConnection,
}: ChannelStatusSectionProps): JSX.Element | null => {
  const canManageChannels = useHasOrganizationAction('manageChannels')
  const isChannelStartPage = isStartPage({ channel })
  const isMobile = useIsMobileScreenSize()

  if (status === Status.Locked && !isChannelStartPage) {
    if (!canManageChannels) {
      return null
    }
    return (
      <UnlockChannelDialog>
        <Button variant="secondary" size="medium">
          <LockOpenIcon />
          Unlock
        </Button>
      </UnlockChannelDialog>
    )
  }

  if (status === Status.Locked && isChannelStartPage) {
    if (!canManageChannels) {
      return null
    }
    return (
      <Button
        variant="secondary"
        size="medium"
        onClick={(): void => {
          window.location.assign(getStartPageUrl(channel.id))
        }}
        aria-label={`Publish to connect ${channel.name || channel.displayName}`}
      >
        {isMobile ? 'Publish' : 'Publish to Connect'}
      </Button>
    )
  }

  if (status === Status.RequiresRefreshing) {
    return (
      <>
        <CriticalIcon color="critical" />
        {!isMobile && <Text color="critical">Requires refreshing</Text>}
        {canManageChannels && (
          <Button
            variant="secondary"
            size="medium"
            onClick={(): void => {
              refreshChannelConnection(
                `publish-channels-channelRefreshButton-${channel.service.toLowerCase()}-1`,
              )
            }}
          >
            Refresh
          </Button>
        )}
      </>
    )
  }

  return null
}

export default ChannelStatusSection
